<template>
  <div>
    <el-tabs v-model="activeTabName" @tab-click="handleTabClick">

      <!-- 批量账号配置 -->
      <el-tab-pane label="批创建账号" name="first">批创建账号
        <el-card>
          <el-form ref="accountInfoFormRef" :rules="accountFormRules" label-width='120px' :model="accountInfoForm">
            <el-form-item prop="account_school" label='选择学校'>
              <el-select
                v-model='accountInfoForm.schoolName'
                filterable
                placeholder='请选择或搜索'
                @change="getSchoolName"
              >
                <el-option
                  v-for='item in schoolList'
                  :key='item.id'
                  :value='item.school_name'
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="account_prfix" label='账号前缀' style="width: 40%;">
              <el-input  v-model='accountInfoForm.account_prfix' placeholder="请输入账号前缀" @change="refreshTeacherAccount(accountInfoForm.account_prfix)"></el-input>
            </el-form-item>
            <el-form-item  label='是否指定密码'>
              <el-switch
                v-model="accountInfoForm.specifiedPWDFlag"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-text="是"
                inactive-text="否">
              </el-switch>
            </el-form-item>
            <el-form-item v-if="accountInfoForm.specifiedPWDFlag" prop="specifiedPWD" label='指定密码' style="width: 40%;">
              <el-input  v-model='accountInfoForm.specifiedPWD' placeholder="默认指定密码为:112233" default></el-input>
            </el-form-item>
            <el-form-item v-if="!accountInfoForm.specifiedPWDFlag" prop="specifiedPWDFlag" label='密码后缀' style="width: 40%;">
              <el-input  v-model='accountInfoForm.pwdbackfix' placeholder="请输入账号密码后缀"></el-input>
            </el-form-item>
            <el-form-item label='账号开始基数'>
              <el-input-number
                v-model='accountInfoForm.startNum'
                @change='handleChangeBase'
                :min='1'
                :max='100'
              ></el-input-number>
            </el-form-item>
            <el-form-item label='账号结束基数'>
              <el-input-number
                v-model='accountInfoForm.endNum'
                @change='handleChangeEnd'
                :min='1'
                :max='100'
              ></el-input-number>
            </el-form-item>
            <el-form-item  label='创建老师账号'>
              <el-switch
                v-model="accountInfoForm.createTeacherFlag"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-text="是"
                inactive-text="否">
              </el-switch>
            </el-form-item>
            <el-form-item v-if="accountInfoForm.createTeacherFlag" label='默认老师账号' style="width: 40%;">
              <el-input v-model='accountInfoForm.teacherAccount'></el-input>
            </el-form-item>
              <el-form-item v-if="accountInfoForm.createTeacherFlag" label='默认老师密码' style="width: 40%;">
              <el-input placeholder="请输入密码" v-model="accountInfoForm.teacherAccountPWD" show-password></el-input>
            </el-form-item>
            <el-form-item label="课程列表">
              <el-card style="width:60%;">
                <el-transfer
                  filterable
                  target-order="push"
                  v-model="accountInfoForm.selectedCousres"
                  :data="CourseList"
                  :titles="['课程列表', '幼儿园课表']"
                  :button-texts="['删除课程', '选择课程']"
                  filter-placeholder="请输入关键字"
                  @change="handCourseChange"
                  :props="{
                    key: 'id',
                    label: 'course_name',
                    disabled:'enabled'
                    }"
                  >
                </el-transfer>
              </el-card>
            </el-form-item>
            <el-form-item>
              <el-button type='primary' @click="onSubmit">立即创建</el-button>
              <el-button>取消</el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </el-tab-pane>

      <!-- 单账户配置 -->
      <el-tab-pane label="单账号配置" name="second">单账号配置
        <el-card>
          <el-form ref="accountInfoFormRef" :rules="accountFormRules" label-width='120px' :model="accountInfoForm">
            <el-form-item prop="account_school" label='选择学校'>
              <el-select
                v-model='accountInfoForm.schoolName'
                filterable
                placeholder='请选择或搜索'
                @change="getSchoolName"
              >
                <el-option
                  v-for='item in schoolList'
                  :key='item.id'
                  :value='item.school_name'
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="!accountInfoForm.createStudentFlag" prop="student_account" label='用户账号' style="width: 40%;">
              <el-input  v-model='accountInfoForm.student_account' placeholder="请输入用户账号"></el-input>
            </el-form-item>
            <el-form-item  label='创建新账号'>
              <el-switch
                v-model="accountInfoForm.createStudentFlag"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-text="是"
                inactive-text="否">
              </el-switch>
            </el-form-item>
            <el-form-item v-if="accountInfoForm.createStudentFlag" label='学生账号' style="width: 40%;">
              <el-input v-model='accountInfoForm.student_account'></el-input>
            </el-form-item>
            <el-form-item v-if="accountInfoForm.createStudentFlag" label='学生昵称' style="width: 40%;">
              <el-input v-model='accountInfoForm.student_nickname'></el-input>
            </el-form-item>
              <el-form-item v-if="accountInfoForm.createStudentFlag" label='学生密码' style="width: 40%;">
              <el-input placeholder="默认密码为112233" v-model="accountInfoForm.student_password" show-password></el-input>
            </el-form-item>
            <el-form-item label="课程列表">
              <el-card style="width:60%;">
                <el-transfer
                  filterable
                  target-order="push"
                  v-model="accountInfoForm.selectedCousres"
                  :data="CourseList"
                  :titles="['课程列表', '幼儿园课表']"
                  :button-texts="['删除课程', '选择课程']"
                  filter-placeholder="请输入关键字"
                  @change="handCourseChange"
                  :props="{
                    key: 'id',
                    label: 'course_name',
                    disabled:'enabled'
                    }"
                  >
                </el-transfer>
              </el-card>
            </el-form-item>
            <el-form-item>
              <el-button type='primary' @click="onSubmitForSigleAccount">立即创建</el-button>
              <el-button>取消</el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </el-tab-pane>

      <!-- 按课程表配置 -->
      <el-tab-pane label="按课程表配置" name="three">按课程表配置权限
        <el-card>
          <el-form ref="accountInfoFormRef" :rules="accountFormRules" label-width='120px' :model="accountInfoForm">
            <el-form-item prop="account_school" label='选择学校'>
              <el-select
                v-model='accountInfoForm.schoolName'
                filterable
                placeholder='请选择或搜索'
                @change="getSchoolName"
              >
                <el-option
                  v-for='item in schoolList'
                  :key='item.id'
                  :value='item.school_name'
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="用户列表">
              <el-card style="width:60%;">
                <el-transfer
                  filterable
                  target-order="push"
                  :data="studentList"
                  :titles="['可选用户列表', '已选用户']"
                  :button-texts="['删除用户', '选择用户']"
                  filter-placeholder="请输入关键字"
                  v-model="selectedusers"
                  @change="handUserChange"
                  :props="{
                    key: 'id',
                    label: 'username',
                    disabled:'enabled'
                    }"
                  >
                </el-transfer>
              </el-card>
            </el-form-item>
            <el-form-item label="课程表列表">
              <el-card style="width:60%;">
                <el-transfer
                  filterable
                  target-order="push"
                  v-model="accountInfoForm.selectcoursetable"
                  :data="CourseTableList"
                  :titles="['可选课程表', '已选课表']"
                  :button-texts="['删除课程表', '选择课程表']"
                  filter-placeholder="请输入关键字"
                  @change="handCourseTableChange"
                  :props="{
                    key: 'id',
                    label: 'name',
                    disabled:'enabled'
                    }"
                  >
                </el-transfer>
              </el-card>
            </el-form-item>
            <el-form-item>
              <el-button type='primary' @click="CreateAccountBasedOnCouserTable">立即创建</el-button>
              <el-button>取消</el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </el-tab-pane>

    </el-tabs>
  </div>
</template>

<script>
export default {
  data() {
    return {
      queryInfo: {
        token: ''
      },
      accountInfoForm: {
        schoolName: '',
        account_prfix: '',
        pwdbackfix: '',
        startNum: 1,
        endNum: 1,
        createTeacherFlag: false,
        specifiedPWDFlag: false,
        specifiedPWD: '112233',
        teacherAccountPWD: 'abc112233',
        teacherAccount: '',
        createStudentFlag: false,
        student_account: '',
        student_nickname: '',
        student_password: '112233'
      },
      activeTabName: 'first',
      schoolList: [],
      CourseList: [],
      studentList: [],
      selectedusers: [],
      CourseTableList: [],
      selectCourseTableList: [],
      total: 0,
      accountFormRules: {
        account_prfix: [
          { required: true, message: '请输入用户名前缀，否则班级无法绑定老师！！！', trigger: 'blur' },
          { min: 2, max: 13, message: '长度在 2 到 13 个字符', trigger: 'blur' }
        ],
        pwdbackfix: [
          { required: true, message: '请输入密码后缀', trigger: 'blur' },
          { min: 2, max: 4, message: '长度在 2 到 6个字符', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.queryInfo.token = window.sessionStorage.getItem('token')
    this.getSchoolList()
    this.getCourseList()
    this.getCourseTableList()
  },
  methods: {
    async getSchoolList() {
      const { data: res2 } = await this.$http.get('schools/')
      this.schoolList = res2
      console.log('schoolList', res2)
      if (res2.length === 0) return this.$notify({ title: '失败', message: '获取学校信息失败!', type: 'error' })
      this.$notify({ title: '成功', message: '获取学校信息成功!', type: 'success' })
    },
    async getCourseList () {
      this.loading = true
      const { data: res } = await this.$http.get('app/courses/', { params: this.queryInfo })
      this.CourseList = res
      this.total = res.length
      console.log(this.CourseList)
      console.log(this.total)
      if (res.total === 0) return this.$notify({ title: '失败', message: '获取课程信息失败!', type: 'error' })
      this.loading = false
      this.$notify({ title: '成功', message: '获取课程信息成功!', type: 'success' })
    },
    async getCourseTableList() {
      const { data: res3 } = await this.$http.get('coursetable/')
      this.CourseTableList = res3
      console.log('CourseTableList', res3)
      if (res3.length === 0) return this.$notify({ title: '失败', message: '获取课程表失败!', type: 'error' })
      this.$notify({ title: '成功', message: '获取课程表成功!', type: 'success' })
    },
    handleTabClick(tab, event) {
      console.log(tab, event)
    },
    handleChangeBase(value) {
      console.log(value)
      this.accountInfoForm.startNum = value
      this.accountInfoForm.endNum = value
    },
    handleChangeEnd(value) {
      console.log(value)
      this.accountInfoForm.endNum = value
    },
    refreshTeacherAccount() {
      this.accountInfoForm.teacherAccount = this.accountInfoForm.account_prfix + 'teacher'
    },
    handCourseChange(selectedCousres) {
      console.log(selectedCousres)
    },
    handUserChange(selectedusers) {
      this.selectedusers = selectedusers
      console.log(selectedusers)
    },
    handCourseTableChange(selectcoursetable) {
      this.selectCourseTableList = selectcoursetable
      console.log(this.selectCourseTableList)
    },
    async getSchoolName(value) {
      this.accountInfoForm.schoolName = value
      const { data: res } = await this.$http.post('V1/getstudent/', { token: this.queryInfo.token, schoolName: value })
      console.log('res', res)
      this.studentList = res
    },
    async onSubmit() {
      console.log('学校:', this.accountInfoForm.schoolName)
      console.log('账号前缀:', this.accountInfoForm.account_prfix)
      console.log('密码后缀:', this.accountInfoForm.pwd_backfix)
      console.log('账号开始基数:', this.accountInfoForm.startNum)
      console.log('账号结束基数:', this.accountInfoForm.endNum)
      console.log('是否创建老师:', this.accountInfoForm.createTeacherFlag)
      console.log('默认老师账号:', this.accountInfoForm.teacherAccount)
      console.log('默认老师密码:', this.accountInfoForm.teacherAccountPWD)
      console.log('选择开通课程:', this.accountInfoForm.selectedCousres)
      console.log('Token:', this.queryInfo.token)
      console.log('准备提交的数据:', this.accountInfoForm)

      this.$refs.accountInfoFormRef.validate(async vaild => {
        if (!vaild) return
        const { data: res } = await this.$http.post('V3/mgr/batchcreatestudent/', { token: this.queryInfo.token, accountInfoForm: this.accountInfoForm })
        console.log('res', res)
        console.log('accountList:', res.accountList)
        if (res.ret !== 4000) {
          this.$notify({ title: '失败', message: '批量创建学生账号失败!' + ' -' + res.msg, type: 'error' })
          this.$router.push('/accountFail')
        } else {
          this.$notify({ title: '成功', message: '批量创建学生账号成功', type: 'success' })
          // 再跳转到home页面
          // this.$router.push('/accountSuccess')
          // ({name: '路由的name ', params: {key: value}})
          this.$router.push({ name: 'accountSuccess', params: { accountList: res.accountList } })
        }
      })
    },
    async onSubmitForSigleAccount() {
      console.log('学校:', this.accountInfoForm.schoolName)
      console.log('选择开通课程:', this.accountInfoForm.selectedCousres)
      console.log('是否新创建账号:', this.accountInfoForm.createStudentFlag)
      console.log('学生账号:', this.accountInfoForm.student_account)
      console.log('学生昵称:', this.accountInfoForm.student_nickname)
      console.log('学生密码:', this.accountInfoForm.student_password)
      console.log('Token:', this.queryInfo.token)
      console.log('准备提交的数据:', this.accountInfoForm)

      this.$refs.accountInfoFormRef.validate(async vaild => {
        if (!vaild) return
        const { data: res } = await this.$http.post('V3/mgr/batchforsiglestudent/', { token: this.queryInfo.token, accountInfoForm: this.accountInfoForm })
        console.log('res', res)
        console.log('accountList:', res.accountList)
        if (res.ret !== 4000) {
          this.$notify({ title: '失败', message: '账号权限更新失败!' + ' -' + res.msg, type: 'error' })
          this.$router.push('/accountFail')
        } else {
          this.$notify({ title: '成功', message: '账号权限更新成功', type: 'success' })
          // 再跳转到home页面
          // this.$router.push('/accountSuccess')
          // ({name: '路由的name ', params: {key: value}})
          this.$router.push({ name: 'accountSuccess', params: { accountList: res.accountList } })
        }
      })
    },
    async CreateAccountBasedOnCouserTable() {
      console.log('学校:', this.accountInfoForm.schoolName)
      console.log('选择开通课程:', this.accountInfoForm.selectedCousres)
    }
  }
}
</script>

<style lang="less" scoped>
  /deep/ .el-transfer-panel{
     width: 300px !important;
  }
</style>
